import { useNavigate } from "react-router-dom";
import { getAssetUrl } from "../../utils/assetUrl";
import { NH_GAME_PROVIDERS } from "./nhMenuGameProviders";
import BackButton from "../../components/BackButton";
import "./HomeNH.css";

const HomeNH = () => {
  const navigate = useNavigate();

  const handleClick = (slotLink: string) => {
    navigate(`/NH/slot${slotLink}`);
  };

  return (
    <div className="nh-hub">
      <header className="ll-game-hero" aria-label="Nổ hũ">
        <BackButton href="/" className="ll-game-hero__back" />
        <h1 className="ll-game-hero__title">HACK SLOT GAME</h1>
      </header>

      <div className="nh-providers-grid">
        {NH_GAME_PROVIDERS.map((e) => (
          <div
            key={e.link}
            className="nh-provider-card"
            onClick={() => handleClick(e.link)}
            onKeyDown={(ev) => {
              if (ev.key === "Enter" || ev.key === " ") {
                ev.preventDefault();
                handleClick(e.link);
              }
            }}
            role="button"
            tabIndex={0}
          >
            <img
              className="nh-provider-card__frame"
              src={getAssetUrl("/assets/llwin/provider-frame.png")}
              alt=""
            />
            <span className="nh-provider-card__logo">
              <img src={getAssetUrl(e.url)} alt={e.name} />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeNH;
